module.exports = __webpack_public_path__ + "static/media/TransferSettings.b9958268.svg";